"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setRevisionConversionError = exports.updateRevisionConversionStatus = void 0;
const ActionTypes = require("../../actionTypes/files/automaticFileConversion");
const updateRevisionConversionStatus = (payload) => ({
    type: ActionTypes.REVISION_CONVERSION_STATUS,
    payload
});
exports.updateRevisionConversionStatus = updateRevisionConversionStatus;
const setRevisionConversionError = (payload) => ({
    type: ActionTypes.REVISION_CONVERSION_ERROR,
    payload
});
exports.setRevisionConversionError = setRevisionConversionError;
//# sourceMappingURL=automaticFileConversion.js.map